import { io } from "socket.io-client";

const Api_Url = "wss://scooteruat-api.tnq.co.in";

const socket = io(Api_Url, {
  transports: ["websocket"],
});
socket.on("connect", () => {
  console.log("Connected to socket:", socket.id);
});

export default socket;